import PropTypes from 'prop-types';
import React from 'react'

import ReplyItem from './ReplyPart-Item'
import ReplySubmit from './ReplyPart-Submit'

import { submitReply } from '~/actions/statement'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.func.isRequired,
		ID: PropTypes.number,
		parent: PropTypes.number,
		statementID: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		user: PropTypes.object.isRequired,
		toggleReplyFlare: PropTypes.func.isRequired
	};

    static contextTypes = {
		store: PropTypes.object
	};

    state = {
        replyOpen: false
    };

    toggleReplyBox = (forceVal) => {
		this.setState({
			replyOpen: typeof forceVal !== 'undefined' ? forceVal : !this.state.replyOpen
		})
	};

    render() {

		let reply = this.props;

		return (
			<div>
				<ReplyItem {...reply} toggleReplyBox={this.toggleReplyBox} toggleFlare={this.props.toggleReplyFlare} />
				{ 'children' in reply && reply.children.length > 0 && 
					reply.children.map(subreply => { 
						return <ReplyItem {...subreply} toggleReplyBox={this.toggleReplyBox} toggleFlare={this.props.toggleReplyFlare} key={'subreply-'+subreply.ID} /> 
					}
				)}
				{ this.state.replyOpen && <ReplySubmit statementID={this.props.statementID} toggleReplyBox={this.toggleReplyBox} parent={reply.ID} /> }
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ReplyParts/ReplyPart-Group.jsx